import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/references/index.js